<template>
    <!-- Desktop filtro aberto e legenda com scroll vertical
         Mobile filtro modal e legenda modal com scroll vertical -->
    <map-page
        :legendMobile="'modal'"
        :filterMobile="'modal'"
        :legendDesktop="'card-vertical-scroll'"
        :filterDesktop="'card'"
        :useMaxWithRanking=false
    />
</template>
<script>
import MapPage from "@/pages/MapPage"

export default {
    components: {
        "map-page": MapPage,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Map/layouts/2.vue